export default "__VITE_ASSET__D6DkzRi4__"